import { getDateString, getUnixDateMs } from '@/plugins/globals.plugin'

const LOG_CID_LDR_EXE = '000A1101'
const LOG_CID_TAMPER_MON = '000A1102'
const LOG_CID_VCRYPTO_HW = '000A1103'
const LOG_CID_SHELL_EXE = '000A2201'
const LOG_CID_DISP_EXE = '000A3301'
const LOG_CID_POOL_THR = '000A3302'
const LOG_CID_REPL_MNR = '000A3303'
const LOG_CID_SNMP_AGENT = '000A3304'
const LOG_CID_NET_MON = '000A3305'
const LOG_CID_LFLUSHER = '000A3306'
const LOG_CID_POOL_AD_THR = '000A3307'
const LOG_CID_ACCEPTOR_THR = '000A3308'
const LOG_CID_SESSION_THR = '000A3309'

// const tidSelection = 0
const cidSelection = 1
const maxLines = 5000

const getDefaultState = () => {
  return {
    parsedLogs: [],
    logs: [],
    logMonReq: null,
    loading: false,
    highlightCID: null,
    highlightTID: null,
    currentHighlight: null,
    lastChunkFinalLine: null,
    lineLimitReached: false,
    CID_MAPPER: {
      [LOG_CID_LDR_EXE]: 'Sys:Loader',
      [LOG_CID_TAMPER_MON]: 'Sys:Tamper Monitor',
      [LOG_CID_VCRYPTO_HW]: 'Sys:Security Supervisor',
      [LOG_CID_SHELL_EXE]: 'Sys:Local Console',
      [LOG_CID_DISP_EXE]: 'Sys:Dispatcher',
      [LOG_CID_POOL_THR]: 'Sys:Thread Pool',
      [LOG_CID_REPL_MNR]: 'Sys:Replication Manager',
      [LOG_CID_SNMP_AGENT]: 'Sys:SNMP Agent',
      [LOG_CID_NET_MON]: 'Sys:HSM Driver',
      [LOG_CID_LFLUSHER]: 'Sys:Log Flusher',
      [LOG_CID_POOL_AD_THR]: 'Sys:Thread Pool Adhoc',
      [LOG_CID_ACCEPTOR_THR]: 'Sys:Thread Acceptor',
      [LOG_CID_SESSION_THR]: 'Sys:Thread Session'
    }
  }
}
const state = {
  parsedLogs: [],
  logs: [],
  logMonReq: null,
  loading: false,
  highlightCID: null,
  highlightTID: null,
  currentHighlight: null,
  lastChunkFinalLine: null,
  lineLimitReached: false,
  CID_MAPPER: {
    [LOG_CID_LDR_EXE]: 'Sys:Loader',
    [LOG_CID_TAMPER_MON]: 'Sys:Tamper Monitor',
    [LOG_CID_VCRYPTO_HW]: 'Sys:Security Supervisor',
    [LOG_CID_SHELL_EXE]: 'Sys:Local Console',
    [LOG_CID_DISP_EXE]: 'Sys:Dispatcher',
    [LOG_CID_POOL_THR]: 'Sys:Thread Pool',
    [LOG_CID_REPL_MNR]: 'Sys:Replication Manager',
    [LOG_CID_SNMP_AGENT]: 'Sys:SNMP Agent',
    [LOG_CID_NET_MON]: 'Sys:HSM Driver',
    [LOG_CID_LFLUSHER]: 'Sys:Log Flusher',
    [LOG_CID_POOL_AD_THR]: 'Sys:Thread Pool Adhoc',
    [LOG_CID_ACCEPTOR_THR]: 'Sys:Thread Acceptor',
    [LOG_CID_SESSION_THR]: 'Sys:Thread Session'
  }
}

const getters = {
  GET_PARSED_LINES: () => ({ newLines }) => {
    const logs = newLines
    if (logs) {
      const logsMap = logs.map(item => {
        const obj = {}
        const pattern = /([0-9]{4})\/([0-9]{2})\/([0-9]{2}) ([0-9]{2}:[0-9][0-9]:[0-9][0-9]) ([0-9A-F]{8}) ([0-9A-F]{8}) ([0-9A-F]{8})\|(.*)/g

        const match = pattern.exec(item)

        if (match && match.length === 9) {
          const date = `${match[1]}-${match[2]}-${match[3]} ${match[4]}`
          const tid = match[5]
          const counter = match[6]
          const cid = match[7]
          const info = match[8]

          obj.unix = getUnixDateMs({ date })
          obj.date = getDateString({ date, needOffset: true, timeDetailLevel: 2 })
          obj.counter = counter
          obj.title = info
          obj.tid = tid
          obj.counter = counter
          obj.cid = cid
          if (Object.prototype.hasOwnProperty.call(state.CID_MAPPER, cid)) {
            obj.cidName = state.CID_MAPPER[cid]
          } else obj.cidName = cid
        }

        return obj
      })
      return logsMap
    }
  }
}

const mutations = {
  SET_HIGHLIGHT (state, { lineObj, selectionType }) {
    if (!lineObj) {
      state.currentHighlight = null
    } else {
      const value = selectionType === cidSelection ? lineObj.cidName : lineObj.tid
      state.currentHighlight = { type: selectionType, val: value }
    }
  },
  SET_LOG_MON_REQ (state, payload = null) {
    state.logMonReq = payload
  },
  ADD_PARSED_LINES_TO_HEAD (state, payload = []) {
    if (!payload.length) return
    let newParsedLogs = payload.concat(state.parsedLogs)
    if (newParsedLogs.length >= maxLines) {
      newParsedLogs = newParsedLogs.slice(0, maxLines)
    }

    state.parsedLogs = newParsedLogs
  },
  RESET_PARSED_LOG (state) {
    state.parsedLogs = []
  },
  SET_LOADING (state, payload = false) {
    state.loading = payload
  },
  SET_LAST_LINE (state, payload) {
    state.lastChunkFinalLine = payload
  },
  TOOGLE_LIMIT_REACHED (state) {
    state.lineLimitReached = !state.lineLimitReached
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  doResetState ({ commit, dispatch }) {
    dispatch('stop')
    commit('resetState')
  },
  setHighlight ({ commit }, { lineObj, selectionType }) {
    commit('SET_HIGHLIGHT', { lineObj, selectionType })
  },
  start ({ getters, state, commit, dispatch, rootState }) {
    try {
      const req = rootState.hsm.instance.getLogMon()
      commit('SET_LOG_MON_REQ', req)

      state.logMonReq
        .on('progress', event => {
          const body = event.currentTarget.response
          const lines = body ? body.split('\n') : []
          // removes empty line at the end
          lines.pop()

          let i = lines.length - 1
          for (; state.lastChunkFinalLine && i >= 0; i--) {
            if (`${lines[i]}` === `${state.lastChunkFinalLine}`) {
              i++
              break
            }
          }

          const newLines = lines.slice(i)
          const newParsedLines = getters.GET_PARSED_LINES({ newLines })
          if (state.parsedLogs.length >= maxLines) {
            commit('TOOGLE_LIMIT_REACHED')
          }
          commit('ADD_PARSED_LINES_TO_HEAD', newParsedLines)
          commit('SET_LAST_LINE', lines[lines.length - 1])
        })
        .then()
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  stop ({ state, commit }) {
    if (state.logMonReq !== null) {
      state.logMonReq.abort()
      commit('SET_LAST_LINE', null)
      commit('SET_LOG_MON_REQ', null)
    }
  }
}

export { state, getters, mutations, actions }
